import { useId, useRef, useState } from "react";
import { PopoverProvider } from "./contexts/PopoverProvider";

type PopoverProps = {
  anchorRef?: React.RefObject<HTMLElement | null>;
  children: React.ReactNode;
  open?: boolean;
  setOpen?: (open: boolean) => void;
};

export function Popover({ anchorRef, children, open, setOpen }: PopoverProps) {
  const triggerRef = useRef<HTMLElement>(null);
  const [openState, setOpenState] = useState(false);
  const popoverId = useId();

  return (
    <PopoverProvider
      anchorRef={anchorRef}
      open={open ?? openState}
      popoverId={popoverId}
      setOpen={setOpen ?? setOpenState}
      triggerRef={triggerRef}
    >
      {children}
    </PopoverProvider>
  );
}
